// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host .pop-up {
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 1001;
  display: flex;
  flex-direction: column;
  justify-content: center;
  box-sizing: border-box;
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  padding: 2rem;
  height: 100vh;
}
:host .pop-up .pop-up-box {
  overflow-y: auto;
  max-height: 100vh;
  margin: 0 auto;
  width: auto;
  min-width: 35rem;
  box-shadow: 5px 10px 8px 0px var(--ods-color-gray-60);
  background: var(--ods-color-white);
  color: var(--ods-color-black);
  position: relative;
  border-radius: 0.375rem;
}
:host .pop-up .pop-up-box__header {
  padding: 0.5rem 1rem;
  border-bottom: 0.0625rem solid var(--ods-color-gray-5) 0;
  color: var(--ods-color-purple-10) 0;
  font-size: 1.25rem;
  display: flex;
}
:host .pop-up .pop-up-box__header-title {
  font-size: 1.25rem;
  margin-right: auto;
}
:host .pop-up .pop-up-box__header-close-button {
  color: var(--ods-color-transparent-black-85);
}
:host .pop-up .pop-up-box__content {
  padding: 1rem;
}
:host .pop-up .pop-up-box__header-title {
  color: var(--ods-color-purple-10) 0;
}
:host .pop-up .pop-up-box .pb-25 {
  padding-bottom: 1.563rem !important;
}
:host .pop-up .pop-up-box .pt-12 {
  padding-top: 0.75rem !important;
}
:host .service-error-container {
  padding: 10px 20px !important;
}

::ng-deep .orchid-button--button {
  margin-right: 1rem;
  font-weight: 700;
}
::ng-deep .orchid-form-control__label {
  font-weight: 700;
  font-size: 0.875rem;
}

@media print {
  .pop-up {
    height: auto !important;
    position: relative !important;
    padding: 0 !important;
  }
  .pop-up .pop-up-box {
    max-height: none !important;
    overflow: unset !important;
    margin: 0 !important;
  }
  orchid-button,
  a {
    display: none !important;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/shared/components/ep-popup/ep-popup.component.scss"],"names":[],"mappings":"AAGE;EACE,oCAAA;EACA,aAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,sBAAA;EACA,eAAA;EACA,OAAA;EACA,QAAA;EACA,MAAA;EACA,aAAA;EACA,aAAA;AAFJ;AAII;EACE,gBAAA;EACA,iBAAA;EACA,cAAA;EACA,WAAA;EACA,gBAAA;EACA,qDAAA;EACA,kCAAA;EACA,6BAAA;EACA,kBAAA;EACA,uBAAA;AAFN;AAIM;EACE,oBAAA;EACA,wDAAA;EACA,mCAAA;EACA,kBAAA;EACA,aAAA;AAFR;AAIQ;EACE,kBAAA;EACA,kBAAA;AAFV;AAKQ;EACE,4CAAA;AAHV;AAQM;EACE,aAAA;AANR;AASM;EACE,mCAAA;AAPR;AAUM;EACE,mCAAA;AARR;AAWM;EACE,+BAAA;AATR;AAgBE;EACE,6BAAA;AAdJ;;AAoBE;EACE,kBAAA;EACA,gBAAA;AAjBJ;AAoBE;EACE,gBAAA;EACA,mBAAA;AAlBJ;;AAsBA;EAEE;IACE,uBAAA;IACA,6BAAA;IACA,qBAAA;EApBF;EAsBE;IACE,2BAAA;IACA,0BAAA;IACA,oBAAA;EApBJ;EAyBA;;IAEE,wBAAA;EAvBF;AACF","sourcesContent":["\n:host {\n\n  .pop-up {\n    background-color: rgba(0, 0, 0, 0.5);\n    z-index: 1001;\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    box-sizing: border-box;\n    position: fixed;\n    left: 0;\n    right: 0;\n    top: 0;\n    padding: 2rem;\n    height: 100vh;\n\n    .pop-up-box {\n      overflow-y: auto;\n      max-height: 100vh;\n      margin: 0 auto;\n      width: auto;\n      min-width: 35rem;\n      box-shadow: 5px 10px 8px 0px var(--ods-color-gray-60);\n      background: var(--ods-color-white);\n      color: var(--ods-color-black);\n      position: relative;\n      border-radius: 0.375rem;\n\n      &__header {\n        padding: 0.5rem 1rem;\n        border-bottom: 0.0625rem solid var(--ods-color-gray-5)0;\n        color: var(--ods-color-purple-10)0;\n        font-size: 1.25rem;\n        display: flex;\n\n        &-title {\n          font-size: 1.25rem;\n          margin-right: auto;\n        }\n\n        &-close-button {\n          color: var(--ods-color-transparent-black-85);\n        }\n\n      }\n\n      &__content {\n        padding: 1rem;\n      }\n\n      &__header-title {\n        color: var(--ods-color-purple-10)0;\n      }\n\n      .pb-25 {\n        padding-bottom: 1.563rem !important\n      }\n\n      .pt-12 {\n        padding-top: 0.75rem !important\n      }\n\n    }\n\n  }\n\n  .service-error-container {\n    padding: 10px 20px !important;\n  }\n\n}\n\n::ng-deep {\n  .orchid-button--button {\n    margin-right: 1rem;\n    font-weight: 700;\n  }\n\n  .orchid-form-control__label {\n    font-weight: 700;\n    font-size: 0.875rem;\n  }\n}\n\n@media print {\n\n  .pop-up {\n    height: auto !important;\n    position: relative !important;\n    padding: 0 !important;\n\n    .pop-up-box {\n      max-height: none !important;\n      overflow: unset !important;\n      margin: 0 !important;\n    }\n  }\n\n\n  orchid-button,\n  a {\n    display: none !important;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
